export default {
  // 主要页面
  'pages.hall-rental.title': '场地预约管理',
  'pages.hall-rental.subTitle': '管理小区场地预约信息',
  'pages.hall-rental.breadcrumb.serviceManagement': '服务管理',
  'pages.hall-rental.breadcrumb.hallRental': '场地预约',

  // 表格相关
  'pages.hall-rental.table.columns.index': '序号',
  'pages.hall-rental.table.columns.hallImage': '场地图片',
  'pages.hall-rental.table.columns.hallName': '场地名称',
  'pages.hall-rental.table.columns.applicantName': '申请人姓名',
  'pages.hall-rental.table.columns.applicantPhone': '联系电话',
  'pages.hall-rental.table.columns.reservationStart': '预约开始时间',
  'pages.hall-rental.table.columns.reservationEnd': '预约结束时间',
  'pages.hall-rental.table.columns.status': '状态',
  'pages.hall-rental.table.columns.remarks': '备注',
  'pages.hall-rental.table.columns.createdTime': '创建时间',
  'pages.hall-rental.table.columns.operations': '操作',

  // 操作按钮
  'pages.hall-rental.table.addReservation': '新建预约',
  'pages.hall-rental.table.batchDelete': '批量删除',
  'pages.hall-rental.table.approve': '审核',
  'pages.hall-rental.table.view': '查看',
  'pages.hall-rental.table.edit': '编辑',
  'pages.hall-rental.table.delete': '删除',

  // 状态相关
  'pages.hall-rental.status.booked': '已预约',
  'pages.hall-rental.status.approved': '已通过',
  'pages.hall-rental.status.rejected': '已拒绝',
  'pages.hall-rental.status.cancelled': '已取消',
  'pages.hall-rental.status.completed': '已完成',
  'pages.hall-rental.status.pending': '待审核',

  // 消息提示
  'pages.hall-rental.message.createSuccess': '创建成功',
  'pages.hall-rental.message.createFailed': '创建失败',
  'pages.hall-rental.message.updateSuccess': '更新成功',
  'pages.hall-rental.message.updateFailed': '更新失败',
  'pages.hall-rental.message.deleteSuccess': '删除成功',
  'pages.hall-rental.message.deleteFailed': '删除失败',
  'pages.hall-rental.message.batchDeleteSuccess': '批量删除成功',
  'pages.hall-rental.message.batchDeleteFailed': '批量删除失败',
  'pages.hall-rental.message.approveSuccess': '审核通过',
  'pages.hall-rental.message.rejectSuccess': '审核拒绝',
  'pages.hall-rental.message.approveFailed': '审核失败',
  'pages.hall-rental.message.selectRecordsToDelete': '请选择要删除的记录',
  'pages.hall-rental.message.batchDeleteConfirm': '确定要删除选中的 {count} 条记录吗？',
  'pages.hall-rental.message.getDataFailed': '获取数据失败',
  'pages.hall-rental.message.selectHall': '请选择场地',
  'pages.hall-rental.message.invalidTimeRange': '预约结束时间必须晚于开始时间',

  // 弹窗标题
  'pages.hall-rental.modal.detailTitle': '预约详情',
  'pages.hall-rental.modal.approvalTitle': '审核预约',
  'pages.hall-rental.modal.createTitle': '新建场地预约',
  'pages.hall-rental.modal.editTitle': '编辑场地预约',

  // 详情信息
  'pages.hall-rental.detail.hallInfo': '场地信息',
  'pages.hall-rental.detail.hallName': '场地名称',
  'pages.hall-rental.detail.hallId': '场地ID',
  'pages.hall-rental.detail.applicantInfo': '申请人信息',
  'pages.hall-rental.detail.applicantName': '申请人姓名',
  'pages.hall-rental.detail.applicantPhone': '联系电话',
  'pages.hall-rental.detail.ownerId': '业主ID',
  'pages.hall-rental.detail.reservationInfo': '预约信息',
  'pages.hall-rental.detail.reservationStart': '预约开始时间',
  'pages.hall-rental.detail.reservationEnd': '预约结束时间',
  'pages.hall-rental.detail.status': '预约状态',
  'pages.hall-rental.detail.remarksInfo': '备注信息',
  'pages.hall-rental.detail.remarks': '备注',
  'pages.hall-rental.detail.noRemarks': '无备注信息',
  'pages.hall-rental.detail.systemInfo': '系统信息',
  'pages.hall-rental.detail.createdTime': '创建时间',
  'pages.hall-rental.detail.createdBy': '创建人',
  'pages.hall-rental.detail.updatedTime': '更新时间',
  'pages.hall-rental.detail.updatedBy': '更新人',

  // 审核相关
  'pages.hall-rental.approval.remarks': '审核意见',
  'pages.hall-rental.approval.remarksPlaceholder': '请输入审核备注（可选）',
  'pages.hall-rental.approval.cancel': '取消',
  'pages.hall-rental.approval.reject': '拒绝',
  'pages.hall-rental.approval.approve': '通过',
  'pages.hall-rental.approval.confirmReject': '确认拒绝',
  'pages.hall-rental.approval.confirmApprove': '确认通过',
  'pages.hall-rental.approval.rejectDescription': '确定要拒绝此场地预约吗？',
  'pages.hall-rental.approval.approveDescription': '确定要通过此场地预约吗？',

  // 表单相关
  'pages.hall-rental.form.hallInfo': '场地信息',
  'pages.hall-rental.form.hallName': '场地名称',
  'pages.hall-rental.form.selectHall': '请选择场地',
  'pages.hall-rental.form.applicantInfo': '申请人信息',
  'pages.hall-rental.form.applicantName': '申请人姓名',
  'pages.hall-rental.form.applicantNamePlaceholder': '请输入申请人姓名',
  'pages.hall-rental.form.applicantPhone': '联系电话',
  'pages.hall-rental.form.applicantPhonePlaceholder': '请输入联系电话',
  'pages.hall-rental.form.search': '查询',
  'pages.hall-rental.form.clear': '清除',
  'pages.hall-rental.form.reservationTime': '预约时间',
  'pages.hall-rental.form.reservationStart': '预约开始时间',
  'pages.hall-rental.form.reservationStartPlaceholder': '请选择预约开始时间',
  'pages.hall-rental.form.reservationEnd': '预约结束时间',
  'pages.hall-rental.form.reservationEndPlaceholder': '请选择预约结束时间',
  'pages.hall-rental.form.status': '预约状态',
  'pages.hall-rental.form.statusPlaceholder': '请选择预约状态',
  'pages.hall-rental.form.statusTooltip': '新建预约默认为待审核状态',
  'pages.hall-rental.form.remarksInfo': '备注信息',
  'pages.hall-rental.form.remarks': '备注',
  'pages.hall-rental.form.remarksPlaceholder': '请输入备注信息（可选）',
  'pages.hall-rental.form.submit': '创建',
  'pages.hall-rental.form.update': '更新',
  'pages.hall-rental.form.cancel': '取消',

  // 表单验证
  'pages.hall-rental.form.validation.applicantNameRequired': '请输入申请人姓名',
  'pages.hall-rental.form.validation.applicantNameMaxLength': '申请人姓名不能超过50个字符',
  'pages.hall-rental.form.validation.applicantPhoneRequired': '请输入联系电话',
  'pages.hall-rental.form.validation.reservationStartRequired': '请选择预约开始时间',
  'pages.hall-rental.form.validation.reservationEndRequired': '请选择预约结束时间',
  'pages.hall-rental.form.validation.statusRequired': '请选择预约状态',

  // 业主选择
  'pages.hall-rental.owner.selectTitle': '选择业主',
  'pages.hall-rental.owner.confirm': '确认选择',
  'pages.hall-rental.owner.cancel': '取消',
  'pages.hall-rental.owner.select': '选择',
  'pages.hall-rental.owner.username': '用户名',
  'pages.hall-rental.owner.name': '姓名',
  'pages.hall-rental.owner.phone': '手机号',
  'pages.hall-rental.owner.email': '邮箱',
  'pages.hall-rental.owner.idCard': '身份证号',
  'pages.hall-rental.owner.role': '角色',
  'pages.hall-rental.owner.status': '状态',

  // 角色状态映射
  'pages.hall-rental.role.owner': '业主',
  'pages.hall-rental.role.tenant': '租户',
  'pages.hall-rental.role.visitor': '访客',
  'pages.hall-rental.status.normal': '正常',
  'pages.hall-rental.status.disabled': '禁用',

  // 通用
  'pages.hall-rental.common.noImage': '暂无图片',
  'pages.hall-rental.common.confirm': '确认',
  'pages.hall-rental.common.cancel': '取消',
};
